import { render, staticRenderFns } from "./JQtryHome.vue?vue&type=template&id=623f1570&scoped=true&"
import script from "./JQtryHome.vue?vue&type=script&lang=js&"
export * from "./JQtryHome.vue?vue&type=script&lang=js&"
import style0 from "./JQtryHome.vue?vue&type=style&index=0&id=623f1570&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "623f1570",
  null
  
)

export default component.exports